export default __webpack_public_path__ + "static/media/Hello-primary.647b63bd.png";